import React from 'react';

const CommentsListItemCommentType = ({ clickAction, displayType, parentType }) => (
  <div>
    { (parentType === 'TsukkomiComment' &&
      <a
        className="f--3 t-mt1 fw3 purple lh-solid link dib"
        href={EMPTY_HREF}
        onClick={e => { e.preventDefault(); clickAction() }}
      >
        {displayType}
      </a>
    ) || <p className="f--3 t-mt1 fw3 purple lh-solid">{displayType}</p>
    }
  </div>
);

CommentsListItemCommentType.defaultProps = {
  clickAction: false,
  displayType: 'Comment',
  parentType: 'NoTsukkomiComment'
};

export default CommentsListItemCommentType;
